import React from "react";

import DeveloperPrivacyLayout from "./developer_privacy_layout";

const DeveloperPrivacyPage = () => {
  return (
    <>
      <DeveloperPrivacyLayout />
    </>
  );
};

export default DeveloperPrivacyPage;